/**
 * 公共状态
 */

// 设置用户信息
export const user = state => state.common.user



// WEBPACK FOOTER //
// ./src/store/getters.js